import clsx from 'clsx'
import styles from './index.module.less' // 导入样式文件
import { useEffect, useRef, useState } from 'react'

const Drawer = ({ open, children, onClose }: any) => {
  const drawerRef = useRef<HTMLDivElement>(null)

  const drawerClasses = clsx(styles.drawer, {
    [styles.open]: open, // 当open为true时应用styles.open
    [styles.close]: !open, // 当open为false时应用styles.close，这里应该只控制位置或透明度等可过渡的属性
  });

  return (

    <div ref={drawerRef} className={drawerClasses}>
      {/* 抽屉内容 */}
      <div className={styles['drawer-content']}>{children}</div>
    </div>
  );
}

export default Drawer
